export default __webpack_public_path__ + "navigation-examples-waypoint-arrival-screen-v1-1200-d2b4b6c66800d3c37b240b3eb7c1f446.webp";